import { axiosNT, axiosNTL } from "../../../services/axios";
import axios from "../../../services/axios";
import { apiToHit, Status, ContentType, Priority } from "../types/Constants";
import CourseData from "../../mylibrary/types/CourseData";
import { ContentRequest, RequestData, AddFeedBack, ResolveFeedback, ReplyFeedback, JobDoneRequest } from "../types/ContentRequest";
import { isLoggedInUserCenterHead, isLoggedInUserMultiCenterHead } from "../helpers/createContentRequest";
import { actionChannel } from "@redux-saga/core/effects";

const getAPIToHit = (
  isBranch: boolean,
  isAdmin: boolean,
  isSuperAdmin: boolean
) => {
  const isMultiCentreHead = !isBranch;

  if (isLoggedInUserCenterHead()) {
    return apiToHit.centreHead;
  }

  if (isLoggedInUserMultiCenterHead()) {
    return apiToHit.multiCentreHead;
  }


  if (!isLoggedInUserMultiCenterHead() && !isLoggedInUserCenterHead()) {
    return apiToHit.contentAuthors;
  }
};

const getAPIURL = (apiToHitData: any) => {
  switch (apiToHitData) {
    case "multiCentreHead":
      return "/content-request/multi-centre-head";
      break;
    case "centreHead":
      return "/content-request/centre-head";
      break;
    case "contentAuthors":
      return "/content-request/creator";
      break;
    default:
  }
};

const getSentContentRequests = (
  isBranch: boolean,
  isAdmin: boolean,
  isSuperAdmin: boolean,
  params: any
) => {

  const url = getAPIURL(getAPIToHit(isBranch, isAdmin, isSuperAdmin));
  // IN PARAMS -> contentType: contentType, Check with backend
  return axiosNT.get(`${url}`, { params: params }).then((res: any) => {
    return Promise.resolve(res.responseObject);
  });
};

const getContentRequest = (requestData: RequestData) => {
  const { requestId,
    isUserCenterhead,
    isUserMultiCenterHead,
    isUserContentAuthor } = requestData;
  //TODO Return CR Object

  if (isLoggedInUserCenterHead()) {
    return axiosNT.get(`/content-request/centre-head/${requestId}`)
      .then((res: any) => {
        return Promise.resolve(res)
      })
  }

  if (isLoggedInUserMultiCenterHead()) {
    return axiosNT.get(`/content-request/multi-centre-head/${requestId}`)
      .then((res: any) => {
        return Promise.resolve(res)
      })
  }

  if (!isLoggedInUserCenterHead() && !isLoggedInUserMultiCenterHead()) {
    return axiosNT.get(`/content-request/owner-task/${requestId}/{role}`)
      .then((res: any) => {
        return Promise.resolve(res)
      })
  }

}

const getReceivedContentRequests = (
  isBranch: boolean,
  isAdmin: boolean,
  isSuperAdmin: boolean,
  params: any
) => {
  const url = getAPIURL(getAPIToHit(isBranch, isAdmin, isSuperAdmin));
  return axiosNT.get(`${url}`, { params: params }).then((res: any) => {
    return Promise.resolve(res.responseObject);
  });
};

const getOwnerTaskByRole = (requestId: string, authorType: string) => {
  return axiosNT
    .get(`/content-request/owner-task/${requestId}/${authorType}`)
    .then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
};
const getFeedback = (contentRequestId: string, contentId: string, pageNumber: number) => {
  return axiosNT
    .get(
      `/content-request-feedback?contentRequestId=${contentRequestId}&contentId=${contentId}&pageNumber=${pageNumber}`
    )
    .then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
};
const getContentRequestIds = (contentId: string) => {
  return axiosNT.
    get(`content-request-item/content-requests/?contentId=${contentId}`).then((res: any) => {
      return Promise.resolve(res.responseObject)
    })
}
const toggleStatus = (
  isBranch: boolean,
  isAdmin: boolean,
  isSuperAdmin: boolean,
  status: Status
) => {
  const url = getAPIURL(getAPIToHit(isBranch, isAdmin, isSuperAdmin));
  return axiosNT
    .get(`${url}`, {
      params: {
        status: status,
      },
    })
    .then((res: any) => {
      return Promise.resolve(res);
    });
};

const createQuestionForPostContentRequest = (reqBody: any): Promise<any> => axiosNTL.post('/content-request-item/request-item', reqBody).then((res: any) => {
  return Promise.resolve(res.responseObject);
})
const createQuestionForPutContentRequest = (id: string, reqBody: any): Promise<any> => axiosNTL.put(`content-request-item/${id}/contents`, reqBody).then((res: any) => {
  return Promise.resolve(res.responseObject);
})
const createQuestionForPutContentRequestForParagraph = (id: string, reqBody: any): Promise<any> => axiosNTL.put(`content-request-item/${id}/content-id`, reqBody).then((res: any) => {
  return Promise.resolve(res.responseObject);
})

const toggleContentType = (
  isBranch: boolean,
  isAdmin: boolean,
  isSuperAdmin: boolean,
  contentType: ContentType
) => {
  const url = getAPIURL(getAPIToHit(isBranch, isAdmin, isSuperAdmin));
  return axiosNT
    .get(`${url}`, {
      params: {
        contentType: contentType,
      },
    })
    .then((res: any) => {
      return Promise.resolve(res);
    });
};

const togglePriority = (
  isBranch: boolean,
  isAdmin: boolean,
  isSuperAdmin: boolean,
  priority: Priority
) => {
  const url = getAPIURL(getAPIToHit(isBranch, isAdmin, isSuperAdmin));
  return axiosNT
    .get(`${url}`, {
      params: {
        priority: priority,
      },
    })
    .then((res: any) => {
      return Promise.resolve(res);
    });
};

const deleteContentRequest = (requestId: string) => {
  if (isLoggedInUserCenterHead()) {
    return axiosNT.delete(`/content-request/centre-head/${requestId}`).then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
  }

  if (isLoggedInUserMultiCenterHead()) {
    return axiosNT.delete(`/content-request/multi-centre-head/${requestId}`).then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
  }
}


// const deleteContentRequest = (payload: any) => {
//   console.log(payload.id);
//   //Comment this back in after checking from where to fire action

//   // if(isLoggedInUserMultiCenterHead()){
//   //   return axiosNT.delete(`/content-request/multi-centre-head/${payload.id}`)
//   //   .then((res: any) => {
//   //     return Promise.resolve(res.responseObject);
//   //   });
//   // }

//   // if(isLoggedInUserCenterHead()){
//   //   return axiosNT.delete(`/content-request/centre-head/${payload.id}`)
//   //   .then((res: any) => {
//   //     return Promise.resolve(res.responseObject);
//   //   }); 
//   // }


// };


const goalList = () =>
  axiosNTL.get("/courseType/active").then((res: any) => {
    const courses: CourseData[] = res.responseObject.courseTypes;
    return Promise.resolve(courses);
  });
const getSubjects = (id: string) => {
  return axiosNTL
    .get(`/courseType/subjects?courseTypeIds=${id}`)
    .then((res: any) => {
      return Promise.resolve(res);
    });
};

const saveContentRequest = (data: ContentRequest) => {
  return axios.post(`/content-request`, data).then((res: any) => {
    const contentRequest = res.responseObject.contentRequest;
    return Promise.resolve(contentRequest);
  });
};

const updateContentRequest = (data: ContentRequest) => {
  return axios.put(`/content-request/${data._id}`, data).then((res: any) => {
    const contentRequest = res.responseObject.contentRequest;
    return Promise.resolve(contentRequest);
  });
};

const resolveReviewRequest = (data: JobDoneRequest) => {
  return axios.put(`/content-request-item/task-done`, data).then((res: any) => {
    const contentRequest = res.responseObject.contentRequest;
    return Promise.resolve(contentRequest);
  });
}
const itemDoneRequest = (data: JobDoneRequest) => {
  return axios.put(`/content-request-item/task-done`, data).then((res: any) => {
    return Promise.resolve(res);
  });
}
const verifyAndNextRequest = (data: JobDoneRequest) => {
  return axios.put(`/content-request-item/item-done`, data).then((res: any) => {
    const contentRequest = res.responseObject.contentRequest;
    return Promise.resolve(contentRequest);
  });
}
const addNewFeedback = (data: AddFeedBack) => {
  return axios.post("/content-request-feedback/comments", data).then((res: any) => {
    const contentRequest = res.responseObject;
    return Promise.resolve(contentRequest);
  });
};
const resolveFeedback = (data: ResolveFeedback) => {
  return axios.post("/content-request-feedback/resolve", data).then((res: any) => {
    const contentRequest = res.responseObject;
    return Promise.resolve(contentRequest);
  });
};
const replyFeedback = (data: ReplyFeedback) => {
  return axios.post("/content-request-feedback/comments", data).then((res: any) => {
    const contentRequest = res.responseObject;
    return Promise.resolve(contentRequest);
  });
};
const getOwners = () => {
  return axiosNTL.get(`/content-request/owners`).then((res: any) => {
    const modifyOwners: any = [];
    res.responseObject.owners.forEach((owner: any) => {
      const newOwner = {
        name: owner.name,
        id: owner._id,
        users: [{
          name: `${owner.users[0].firstName} ${owner.users[0].lastName}`,
          id: owner.users[0]._id
        }]
      };
      modifyOwners.push(newOwner);
    });
    res.responseObject.owners = modifyOwners;
    return Promise.resolve(res);
  });
};

const getRequestProgress = (requestId: string, isMultiCenterHead: boolean, showDetails = false) => {
  // const urlByUserType = isMultiCenterHead ? "multi-centre-head" : "centre-head";
  if (isMultiCenterHead) {
    return axios
      .get(`/content-request/multi-centre-head/${requestId}`, { params: { details: showDetails } })
      .then((res: any) => {
        return Promise.resolve(res.responseObject);
      });
  } else {
    return axios
      .get(`/content-request/centre-head/${requestId}`, { params: { details: showDetails } })
      .then((res: any) => {
        return Promise.resolve(res.responseObject);
      });
  }

};

const userSuggestionByRole = (role: string, searchQuery: string) => {
  return axiosNTL
    .get(`/user/users-by-role?role=${role}&module=test&searchQuery=${searchQuery}`)
    .then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
}


const searchContentRequests = (params: any) => {
  const isMultiCenterHead = isLoggedInUserMultiCenterHead();
  const isCenterHead = isLoggedInUserCenterHead();
  const isAuthor = (!isLoggedInUserMultiCenterHead() && !isLoggedInUserCenterHead());
  let URL = '';
  if (isMultiCenterHead) {
    URL = '/content-request/multi-centre-head'
  }
  if (isCenterHead) {
    URL = '/content-request/centre-head'
  }
  if (isAuthor) {
    URL = '/content-request/creator'
  }

  let checkedParams: any = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== "") {
      checkedParams[key] = value;
    }
  }

  return axiosNTL
    .get(URL,
      {
        params: checkedParams
      })
    .then((res: any) => {
      return Promise.resolve(res.responseObject);
    })
}

const saveQuestions = (contentRequestItemId: String, data: any) => {
  return axios.put(`/content-request-item/${contentRequestItemId}/content-id`, data)
    .then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
};

const resetQuestions = (contentRequestItemId: String, contentId: any) => {
  return axios.delete(`/content-request-item/${contentRequestItemId}/${contentId}`)
    .then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
};

const getJobDoneApi = (data: any) => {
  return axios.put(`/content-request-item/item-done`, data)
    .then((res: any) => {
      return Promise.resolve(res);
    });
};

const resetForUnresolvedCount = (body: any) =>
  axios.put('content-request-item/reset-content', body).then((response: any) => {
    return Promise.resolve(response);
  })

const fetchContentRequestHistory = (params: any) => {
  return axiosNT.get(`/content-request-history`, { params }).then((response: any) => {
    return Promise.resolve(response.responseObject)
  })
  
}

const getValidationData = (params: any) => {
  return axiosNTL.get(`/content-validation/request`, { params }).then((response: any) => {
    if (response.statusCode === 200) {
      return Promise.resolve(response.responseObject);
    }
    Promise.reject(response.responseObject);
  })
};

const submitValidatorAction = (payload: any) => {
  return axios.patch(`/content-validation/validator/action`, payload).then((response: any) => {
    if (response.statusCode === 200) {
      return Promise.resolve(response.responseObject);
    }
    return Promise.reject(response.responseObject);
  })
};

const startNewValidation = (type: string) => {
  return axios.get(`/content-validation/new-validation?authorType=${type}`).then((response: any) => {
    if (response.statusCode === 200) {
      return Promise.resolve(response.responseObject);
    }
    Promise.reject(response.responseObject);
  })
};

const getValidationStats = (params: any) => {
  return axios.get(`/content-validation/statistics`, { params }).then((response: any) => {
    if (response.statusCode === 200) {
      return Promise.resolve(response.responseObject);
    }
    Promise.reject(response.responseObject);
  })
};

const submitAuthorAction = (payload: any) => {
  return axios.patch(`/content-validation/feedbacks`, payload).then((response: any) => {
    if (response.statusCode === 200) {
      return Promise.resolve(response.responseObject);
    }
    return Promise.reject(response.responseObject);
  })
};

const submitContentForValidation = (payload: any) => {
  return axios.post(`/content-validation`, payload).then((response: any) => {
    if (response.statusCode === 200) {
      return Promise.resolve(response.responseObject);
    }
    Promise.reject(response.responseObject);
  })
};

const getAcademicYearList = (stat: string, startYear: any = '', endYear: any = '') => {
  return axiosNT.get(`content-validation/statistics?statType=${stat}&startYear=${startYear}&endYear=${endYear}`).then((res: any) => {
    return Promise.resolve(res.responseObject || []);
  })
}

const getValidationTabStatus = () => {
  return axiosNT.get(`/content-validation/action-pending-tabs`).then((res: any) => {
    return Promise.resolve(res.responseObject || {});
  });
}

const generatePreviewTestToken = (id: string) => {
  return axiosNT.get(`/user/glorifire-token?testId=${id}`).then((res: any) => {
    return Promise.resolve(res.responseObject || {});
  })
}

const fetchRecentSuggestions = (bucketType: string) => {
  return axiosNTL.get(`/global-search/user-tags?bucketType=${bucketType}`).then((res: any) => {
    return Promise.resolve(res || {});
  })
} 

const fetchSearchResults = (query: any) => {
  return axiosNTL.get(`/global-search/tag-suggestions?searchText=${query.searchText}&bucketType=${query.bucketType}`).then((res: any) => {
    return Promise.resolve(res || {});
  })
}

const addTagsToRecentSearchResults = (bucketType: string, payload: any) => { 
  return axiosNTL.put(`/global-search/user-tags?bucketType=${bucketType}`, payload).then((res: any) => {
    return Promise.resolve(res || {});
  })
}

const contentRequestServices = {
  getSentContentRequests,
  getReceivedContentRequests,
  saveQuestions,
  deleteContentRequest,
  getOwnerTaskByRole,
  toggleContentType,
  goalList,
  getSubjects,
  getFeedback,
  getContentRequestIds,
  getOwners,
  addNewFeedback,
  resolveFeedback,
  replyFeedback,
  getRequestProgress,
  saveContentRequest,
  updateContentRequest,
  getContentRequest,
  userSuggestionByRole,
  resolveReviewRequest,
  itemDoneRequest,
  verifyAndNextRequest,
  createQuestionForPutContentRequest,
  createQuestionForPutContentRequestForParagraph,
  createQuestionForPostContentRequest,
  resetQuestions,
  getJobDoneApi,
  searchContentRequests,
  resetForUnresolvedCount,
  fetchContentRequestHistory,
  getValidationData,
  submitValidatorAction,
  startNewValidation,
  getValidationStats,
  submitAuthorAction,
  submitContentForValidation,
  getAcademicYearList,
  getValidationTabStatus,
  generatePreviewTestToken,
  fetchRecentSuggestions,
  fetchSearchResults,
  addTagsToRecentSearchResults
}

export default contentRequestServices
